import base from './base.repository';
import base2 from './base2.repository';

export default {
    ...base,
    login(username, password) {
        // const noCache = Math.round(Math.random()*10000000000);
        return this.post(`auth/login`, {username, password});
    },
    registerUser(payload){
        return this.post('auth/register', payload);
    },
    recoverPassword(payload){
        return this.post('users/recover-password', payload);
    },
    changePassword(payload){
        // this.post('users/change-password-user', {userId: payload.userId, password1: payload.password1, password2: payload.password2, oldPassword: payload.oldPassword}); this.post('users/change-password-user', {userId: payload.userId, password1: payload.password1, password2: payload.password2, oldPassword: payload.oldPassword});
        return this.post('users/change-password-user', payload);
    },
    saveBrowserSpects: (userId, spects) => base2.post(`users/${userId}/browser-spects`, spects),
    saveNotificationsSupport: (userId, support) => base2.post(`users/${userId}/notifications-support`, support),
    saveNotificationsAllowed: (userId, allowed) => base2.post(`users/${userId}/notifications-allowed`, allowed),
    updateEmail: (userId, email) => base2.post(`users/${userId}/update-email`, { email }),
    confirmCode: (userId, code) => base2.post(`users/${userId}/confirm-code`, { code })
};



// WEBPACK FOOTER //
// ./src/repositories/auth.repository.js